module.exports = __webpack_public_path__ + "img/logo_keplr.61e1058a.png";